import PropTypes from "prop-types"
import RegistrationButton from "./RegistrationButton"
import TransactionDropdown from "./TransactionDropdown"

const Transactions = ({ registration }) => {
  return (
    <>
      <h4 className="d-n d-b@print">Cost breakdown</h4>
      <section className="pane p-2 mb-1">
        {registration.payments.length > 0 && (
          <TransactionDropdown
            title="Payments"
            totalText="Total paid"
            totalAmount={registration.totalPaymentsStr}
            transactions={registration.payments}
          />
        )}

        {registration.refunds.length > 0 && (
          <TransactionDropdown
            title="Refunds"
            totalText="Total refunded"
            totalAmount={registration.totalRefundsStr}
            transactions={registration.refunds}
          />
        )}

        <dl className="d-f jc-sb d-f@print jc-sb@print">
          {registration.isRefundDue && (
            <>
              <dt className="c-danger">
                <strong>Refund due</strong>
              </dt>
              <dd className="c-danger">
                <strong>{registration.refundDueStr}</strong>
              </dd>
            </>
          )}
          {!registration.isRefundDue && (
            <>
              <dt>
                <strong>Balance due</strong>
              </dt>
              <dd>
                {registration.totalDue === 0 && (
                  <span className="p-r t-2p mr-4p c-success font-size-4">
                    <Icon symbol="general#check" />
                  </span>
                )}
                <strong>{registration.totalDueStr}</strong>
              </dd>
            </>
          )}
        </dl>
      </section>
      <div className="d-f@sm ai-c jc-fe mb-4">
        <div className="d-f@sm ai-c jc-fe" css={{ gap: "0.5rem" }}>
          <RegistrationButton modalUrl={registration.paths.newPayment}>
            Apply payment
          </RegistrationButton>

          <RegistrationButton modalUrl={registration.paths.newRefund} buttonClass="quiet-btn">
            Issue refund
          </RegistrationButton>
        </div>
      </div>
    </>
  )
}

Transactions.propTypes = {
  registration: PropTypes.shape({
    payments: PropTypes.array,
    totalPaymentsStr: PropTypes.string,
    refunds: PropTypes.array,
    totalRefundsStr: PropTypes.string,
    isRefundDue: PropTypes.bool,
    refundDueStr: PropTypes.string,
    totalDue: PropTypes.string,
    totalDueStr: PropTypes.string,
    paths: PropTypes.shape({
      newPayment: PropTypes.string,
      newRefund: PropTypes.string
    })
  })
}

export default Transactions
